<template>
  <v-row>
    <v-col>
      <v-card
        flat
        class="comment-card"
      >
        <v-card-title>
          <v-list-item
            class="grow comment-title"
            :title="comment.userName"
          >
            <template #prepend>
              <v-avatar class="comment-avatar">
                {{ comment.userInitials }}
              </v-avatar>
            </template>

            <template #append>
              <span class="comment-date mr-2">{{ comment.createdAt }}</span>
            </template>
          </v-list-item>
        </v-card-title>

        <v-card-text>
          <p>
            {{ comment.comment }}
          </p>

          <OpsTicketImages
            :only-gallery="true"
            download
            :show-type="'comment'"
            :ticket-images="comment.images"
          />
        </v-card-text>
      </v-card>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
import OpsTicketImages from '@/views/Helpdesk/components/OpsTicketDashboard/OpsTicketImages.vue';

export default {
  name: 'OpsTicketDialogCommentCard',
  components: { OpsTicketImages },

  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.v-dialog .v-card__title {
  background: white !important;
}

.comment-date {
  font-size: 0.75rem;
  font-weight: 300;
}

.comment-avatar {
  color: #d9e6e8d2;
  border: solid 1px #d9e6e8d2;
  background-color: grey;
}

.comment-title {
  padding: 0;
}

.v-application--is-ltr .v-list-item__avatar:first-child {
  margin-right: 0.5rem;
}
</style>
